import { Sides } from "@project/emerge-types";
import type { SunlabsConnectorType } from "./enum/SunlabsConnectorType";
import type { SunlabsCount } from "./enum/SunlabsCount";
import { SunlabsSides } from "./enum/SunlabsSides";

export const sunlabSide2SidesAndMirror = (sunlabsSide: SunlabsSides) => {
  let side: Sides;
  let mirror = false;
  switch (sunlabsSide) {
    case SunlabsSides.FrontBack:
      side = Sides.FRONT;
      mirror = true;
      break;
    case SunlabsSides.LeftRight:
      side = Sides.LEFT;
      mirror = true;
      break;
    case SunlabsSides.Back:
      side = Sides.BACK;
      break;
    case SunlabsSides.Front:
      side = Sides.FRONT;
      break;
    case SunlabsSides.Left:
      side = Sides.LEFT;
      break;
    case SunlabsSides.Right:
      side = Sides.RIGHT;
      break;
    case SunlabsSides.Bottom:
      side = Sides.BOTTOM;
      break;
    case SunlabsSides.Top:
      side = Sides.TOP;
      break;
    default:
      throw new Error(`unknown sunlabs side ${sunlabsSide}`);
  }
  return { side, mirror };
};

export type sType =
  | string
  | typeof SunlabsCount
  | typeof SunlabsConnectorType
  | typeof SunlabsSides;
export const parseSunlabsString = <
  T1,
  T2 = undefined,
  T3 = undefined,
  T4 = undefined,
>(
  sunlabsString: string,
  ...args: sType[]
): [T1, T2, T3, T4] => {
  const r =
    "^" +
    args
      .map((a) => {
        if (typeof a === "object") {
          return `(${Object.keys(a).join("|")})`;
        } else {
          return a;
        }
      })
      .join("") +
    "$";
  const result = sunlabsString.match(new RegExp(r));
  if (result === null || result.length < 2) {
    throw new Error(`${r} did not match: ${sunlabsString}`);
  } else {
    return result.slice(1) as unknown as [T1, T2, T3, T4];
  }
};
